
import React from 'react';

export const PaperClipIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    attachment
  </span>
);